module.exports = __webpack_public_path__ + "images/file_icons_v2/xls-8198146968be835fc29e9d7394811ee0.svg";